export default {
  "content": "<path d=\"M9.62 6.382a2 2 0 11-4 0 2 2 0 014 0z\"/><path fill-rule=\"evenodd\" d=\"M7 .912c.2-.02.41-.03.62-.03h.01c.21 0 .42.01.62.03 3.87.39 6.07 4.68 4.48 8.23l-4.1 7.14c-.21.4-.6.6-1 .6s-.79-.2-1-.6l-4.11-7.14C.93 5.592 3.13 1.302 7 .912zm1.14 1c-.17-.03-.34-.03-.52-.03l.01-.01c-.18 0-.35.01-.52.03-1.43.14-2.68.97-3.43 2.26-.8 1.39-.89 3.07-.26 4.52l4.08 7.11.13.1.11-.07 4.09-7.13c.63-1.45.54-3.14-.26-4.52-.75-1.29-2-2.11-3.43-2.26z\" clip-rule=\"evenodd\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "17",
    "fill": "currentColor",
    "viewBox": "0 0 16 17"
  }
};